export { AssignOrderComponent } from './assign-order.component';

export { OrdersFormComponent } from './orders-form.component';

export { OrdersListComponent } from "./orders-list.component";
